module.exports = __webpack_public_path__ + "img/5.736eb08f.jpg";